function state() {
  return {
    permissions: [],
    permission: {},
  };
}

export default state;
